import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { 
  Character,
  // CharacterFeatureSource,
  CharacterSheetInterface,
  Modifier,
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import StringBox from "@components/input/strings/StringBox";
import FloatMenu from "@components/input/menus/FloatMenu";
import CharacterFeatureFromSource from "@dndComponents/character/features/CharacterFeatureFromSource";
import CharacterACCustomizations from '../customizations/CharacterACCustomizations';

interface Props {
  char: Character;
  char_int: CharacterSheetInterface;
  disabled: boolean;
  // onChange: () => void;
  // onSourceChange: (source: CharacterFeatureSource, do_main: boolean) => void;
}

const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterAC({ 
  char,
  char_int,
  // disabled,
  // onChange,
  // onSourceChange
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [view, setView] = useState("Features");

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const renderACFeatures = () => {
    const ac_features = char_int.mind.modifier_features.filter(cf => 
      cf.floating_feature instanceof Modifier && 
        ["AC"].includes(cf.floating_feature.modifies));
    return (
      <>
        <Grid
          className="header centered"
          size={{
            xs: 12
          }}>
          Armor Class Features
        </Grid>
        { ac_features.sort((a,b) => { return a.name.localeCompare(b.name) }).map((char_feature, key) => {
          const source = char_int instanceof Character ? char_int.char_feature_sources.find(o => 
            o.true_id === char_feature.source_true_id) : null;
          if (source) {
            return (
              <Grid
                key={key}
                size={{
                  xs: 12
                }}>
                <CharacterFeatureFromSource
                  char={char}
                  obj={char_feature}
                  source={source}
                />
              </Grid>
            );
          }
          return null;
        })}
      </>
    );
  }

  const renderView = () => {
    switch(view) {
      // case "Current": return renderCurrent();
      case "Features": return renderACFeatures();
      // case "Bonus Proficiencies": return renderBonusACProfs();
      case "Customize": return (<Grid size={12}><CharacterACCustomizations char={char} char_int={char_int} /></Grid>);
    }
    return null;
  }

  const options = ["Features","Customize"];
  return (
    <Grid
      container
      spacing={0}
      direction="row"
      size={{
        xs: 12
      }}>
      <Grid
        className="centered header"
        size={{
          xs: 12
        }}>
        Manage Armor Class
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <FloatMenu
          options={options}
          selected={view}
          onSelect={setView}
        />
      </Grid>
      { renderView() }
    </Grid>
  );
}
